import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';

import { isThirdMolarTooth } from '@/entities/tooth';

import { PURPLE_CODES, RED_CODES, YELLOW_CODES } from '../config/const';
import { ConditionColor } from '../config/types';

export const getConditionCodeColor = (
  code: ConditionCode,
  isConditionUncertain: boolean,
  showLowProbability: boolean = false,
  ISONumber: number,
): ConditionColor => {
  if (code === ConditionCode.Missing && isThirdMolarTooth(ISONumber)) {
    return 'white';
  }

  if (
    showLowProbability &&
    YELLOW_CODES.includes(code) &&
    isConditionUncertain
  ) {
    return 'yellow';
  }

  if (RED_CODES.includes(code)) {
    return 'red';
  }

  if (PURPLE_CODES.includes(code)) {
    return 'purple';
  }

  return 'white';
};
